import { AuthToken } from '@libs/shared/models';
import { Observable, throwError } from 'rxjs';

export abstract class AuthHandler<TokenModel = unknown> {
  public abstract login(): Observable<TokenModel | undefined>;

  public abstract logout(): Observable<void>;
}

export abstract class UserAuthHandler extends AuthHandler<AuthToken> {
  public register(): Observable<AuthToken | undefined> {
    return throwError(() => new Error('Registration is not supported in this auth context'));
  }

  public abstract refresh(): Observable<AuthToken | undefined>;
}

export interface UserAuthStateModel {
  user: boolean;
  agent: boolean;
}
